module.exports = __webpack_public_path__ + "static/flags/SM-241d2b6c705e67584939a6a4fba1d0e2.gif";